<form *ngIf="form" (ngSubmit)="onSubmit()" autocomplete="off" [formGroup]="form" class="d-flex flex-column gap-20 relative">
  <div class="divider"></div>

  <div [hidden]="!loading" class="spinner">
    <div class="sk-spinner sk-spinner-pulse"></div>
  </div>
  <div class="form-row d-flex gap-15">
    <div class="form-group w-100">
      <label class="form-label required">Name </label>
      <span class="icon-help-1 text-neutral-n6 ms-0_5"
        tooltip="An identifier for your SIP configuration. Helps distinguish between multiple trunks you have."></span>
      <input formControlName="name" type="text" class="form-control" required />
      <input-errors [control]="form.controls.name" [service]="validationService"></input-errors>
    </div>
  </div>
  <div class="form-row d-flex gap-15">
    <div class="form-group w-100">
      <label class="form-label required">Protocol </label>
      <span class="icon-help-1 text-neutral-n6 ms-0_5" tooltip="Select the protocol used by your SIP server (currently only UDP protocol is supported)."></span>
      <select formControlName="protocol" class="form-control">
        <option *ngFor="let p of service.protocols" [value]="p">{{ p }}</option>
      </select>
      <input-errors [control]="form.controls.protocol" [service]="validationService"></input-errors>
    </div>
    <div class="form-group w-100">
      <label class="form-label required">Host </label>
      <span class="icon-help-1 text-neutral-n6 ms-0_5" tooltip=" The IP address or domain name of your SIP server."></span>
      <input formControlName="host" type="text" class="form-control" required />
      <input-errors [control]="form.controls.host" [service]="validationService"></input-errors>
    </div>
    <div class="form-group w-100">
      <label class="form-label required">Port </label>
      <span class="icon-help-1 text-neutral-n6 ms-0_5" tooltip="The port on which your SIP server is listening (e.g., 5060)."></span>
      <input formControlName="port" type="text" class="form-control" required />
      <input-errors [control]="form.controls.port" [service]="validationService"></input-errors>
    </div>
  </div>
  <div class="form-row d-flex gap-15">
    <div class="form-group w-100">
      <label class="form-label" [ngClass]="{ required: usernameRequired }">Username </label>
      <input formControlName="username" autocomplete="off" type="text" class="form-control" pm-ignore />
      <input-errors [control]="form.controls.username" [service]="validationService"></input-errors>
    </div>
    <div class="form-group w-100">
      <label class="form-label" [ngClass]="{ required: passwordRequired }">Password </label>
      <input formControlName="password" type="password" autocomplete="new-password" class="form-control" pm-ignore />
      <input-errors [control]="form.controls.password" [service]="validationService"></input-errors>
    </div>
  </div>
  <div class="form-row d-flex gap-15">
    <div class="form-group w-100">
      <label class="form-label">Prefix </label>
      <span class="icon-help-1 text-neutral-n6 ms-0_5"
        tooltip="A string that is automatically prepended to the destination number (the number being dialed) when a test call is sent through this SIP trunk. Some SIP providers use this prefix to select a route, then strip it before forwarding the call to the intended destination. These prefixes are typically numeric but may include special characters (e.g., 025#, *999)."></span>
      <div class="alert alert-primary" role="alert">
        <b>Please note:</b> Only one prefix can be set per SIP trunk configuration. Leave empty if no prefix is
        needed.
      </div>
      <input formControlName="prefix" type="text" class="form-control" />
      <input-errors [control]="form.controls.prefix" [service]="validationService"></input-errors>
    </div>
    <div class="form-group w-100">
      <label class="form-label required">Throughput (Call/second) </label>
      <span class="icon-help-1 text-neutral-n6 ms-0_5" tooltip="The rate at which your SIP server can send calls. "></span>
      <div class="alert alert-primary" role="alert">
        Please ensure that CPS is aligned between your SIP server and our platform to avoid congestion or call
        rejection.
      </div>
      <input formControlName="cps" type="number" class="form-control" />
      <input-errors [control]="form.controls.cps" [service]="validationService"></input-errors>
    </div>
  </div>
  <div class="form-row d-flex gap-15">
    <div class="form-group">
      <div class="d-flex align-items-center gap-2 form-label">
        <label>Use OPTIONS request for pings</label>
        <span class="icon-help-1 text-neutral-n6 ms-0_5"
          [tooltip]="'SIP OPTIONS ping is a mechanism for checking the reachability of a SIP endpoint. It is typically used to monitor the status of a trunk. We recommend keeping this option enabled. You can turn it off when you have other reliable mechanisms for detecting endpoint availability, or when the overhead of OPTIONS pings is undesirable.'"
          tooltipPlacement="right"></span>
      </div>
      <div class="form-check form-switch">
        <input type="checkbox" class="form-check-input medium" formControlName="pingEnabled" />
      </div>
    </div>
  </div>
  <div class="step-buttons">
    <button type="button" class="btn btn-outline-dark px-20" (click)="onCancel.emit()">Cancel</button>
    <div class="d-flex w-100 justify-content-end align-items-center gap-10">
      <div class="d-flex align-items-center gap-10">
        <label for="Enabled" class="form-label mb-0">Enabled</label>
        <div class="form-check form-switch">
          <input type="checkbox" class="form-check-input medium" formControlName="enabled" />
        </div>
      </div>
      <div class="v-line"></div>
      <button type="submit" class="btn btn-primary px-20" [disabled]="!form.valid">
        {{this.model.id ? 'Apply' : 'Create'}}
      </button>
    </div>
  </div>
</form>
